export enum UserTypes {
  VENDEDOR = 1,
  GESTOR  = 2,
  SAC   = 3,
  ADMIN = 4,
  COORDENADOR  = 5,
}
